import { Collapse } from "antd";
import type { ChapterDto, ObjectiveDto } from "../../../types/client-education-detail.types";
import { ObjectiveRow } from "./ObjectiveRow";
import styles from "./ContentSection.module.scss";

export function ChapterAccordion(props: {
  chapters: ChapterDto[];
  activeObjectiveId: string | null;
  onSelectObjective: (obj: ObjectiveDto) => void;
}) {
  const { chapters, activeObjectiveId, onSelectObjective } = props;
  return (
    <Collapse
      defaultActiveKey={chapters.map((c) => c.id)}
      className={styles.accordion}
      items={chapters.map((c) => ({
        key: c.id,
        label: (
          <div className={styles.chapterHead}>
            <strong>{c.title}</strong>
            <span className={styles.chapterMeta}>
              {c.progressPercentage != null ? `%${Math.round(c.progressPercentage)}` : ""}
              {c.durationHours != null || c.durationMinutes != null
                ? ` · ${c.durationHours ?? 0}sa ${c.durationMinutes ?? 0}dk`
                : ""}
            </span>
          </div>
        ),
        children: (
          <div className={styles.objList}>
            {c.objectives.map((o) => (
              <ObjectiveRow
                key={o.id}
                objective={o}
                active={o.id === activeObjectiveId}
                onSelect={() => onSelectObjective(o)}
              />
            ))}
          </div>
        ),
      }))}
    />
  );
}
